import { GridItem } from '@bnnvara/grids';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import React from 'react';

import ArticleCard from '../../cards/ArticleCard';
import BaseVideoCard from '../../cards/VideoCard';
import Link from '../../Link';

const transformVideoItem = (item, index, recomType) => ({
  title: item.title,
  image: item.image ? item.image.url : null,
  publishDate: item.publishDate,
  brandName: item.brandName,
  mediaType: item.mediaType,
  index,
  recomType,
});

const transformArticleItem = (item, index, recomType) => ({
  title: item.title,
  publishDate: item.publishDate,
  thumbnail: {
    url: item.imageUrl,
  },
  commentCount: item.commentCount,
  brand: item.brand,
  index,
  recomType,
  requiresMembership: item.requiresMembership,
  commentsEnabled: item.commentsEnabled,
});

const RecommendedItem = ({ uri, recomType, index, ...item }) => {
  const { asPath } = useRouter();
  let element;
  let category;

  if (['videos', 'audio'].includes(asPath)) {
    category = 'MediaDetailPage';
  }

  if (asPath.includes('artikelen')) {
    category = 'ArticleDetailPage';
  }

  if (asPath.includes('catalogus')) {
    category = 'CatalogDetailPage';
  }

  if (['Media'].includes(item.__typename)) {
    const videoItem = transformVideoItem(item, index, recomType);
    element = <BaseVideoCard {...videoItem} />;
  }

  if (['Article', 'Page', 'Question'].includes(item.__typename)) {
    const articleItem = transformArticleItem(item, index, recomType);
    element = <ArticleCard {...articleItem} />;
  }

  if (!element) {
    return null;
  }

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      key={uri}
    >
      <Link
        href={uri}
        category={category}
        action="click"
        label={`${recomType}${index}`}
      >
        {element}
      </Link>
    </GridItem>
  );
};

RecommendedItem.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string,
  brand: PropTypes.string,
  type: PropTypes.string,
  uri: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  index: PropTypes.string.isRequired,
  recomType: PropTypes.string.isRequired,
};

RecommendedItem.defaultProps = {
  brand: null,
  publishDate: Date.now(),
  imageUrl: null,
  type: null,
};

export default RecommendedItem;
